<template>
	<div id="orthoPlayStagesDiv" class="ortho-controls">
		<button class="ortho-button orto-report-button" v-on:click="anatomyChangeReportClick()">
			ANATOMY CHANGE REPORT
		</button>

		<div id="orthoPlaySlider">
			<div id="playSlider" class="horizontal-slider"></div>

			<img id="orthoPlayBtn" class="ortho-play-img" v-on:click="switchPlayClick()"
				:src="isOrthoPlaying ? 'images/pause.png' : 'images/play.png'" />

			<img id="orthoCloseBtn" class="ortho-play-img" v-on:click="closePlayClick()" src="images/cross.png" />
		</div>

		<div id="orthoPlayStages">
			<button id="originalStage" class="ortho-stage ui-button ui-widget ui-corner-all"
				v-on:click="loadStageClick(-1)">
				{{ windowWidth > 650 ? "Original" : "S0" }}
			</button>

			<button v-for="(stage, index) in midStages" :key="stage.name"
				v-bind:style="{ left: 'calc(' + (index + 1) * proportion + '% - 17px)' }"
				v-on:click="loadStageClick(stage.id)" :title="stage.name"
				class="ortho-stage ortho-stage-mid ui-button ui-widget ui-corner-all">
				{{ "S" + stage.id }}
			</button>

			<span v-for="(stage, index) in midStages" :key="stage.id"
				v-bind:style="{ left: 'calc(' + (index + 1) * proportion + '% - 8px)', top: '-31px' }"
				v-on:click="loadStageClick(stage.id)" :title="stage.name"
				class="ui-slider-handle ui-corner-all ui-state-default ortho-ellipse"></span>

			<!-- <button id="lastStage" class="ortho-stage ui-button ui-widget ui-corner-all"
				v-on:click="loadStageClick(0)">
				{{windowWidth > 650 ? "Last Save" : "Sn"}}
			</button> -->
		</div>

	</div>
</template>

<script>
import { loadOrthoStage, switchOrthoPlay, clearOrtoAccesories } from "./OrthoPlanMode";
import { anatomyChangeReport } from "./OrtoReporting";

export default {
	name: "OrthoPlayStages",
	props: ["currentStages", "orthoStages", "isOrthoPlaying"],
	data() {
		return {
			windowWidth: window.innerWidth
		};
	},
	methods: {
		anatomyChangeReportClick: function () {
			anatomyChangeReport();
		},
		switchPlayClick: function () {
			switchOrthoPlay(!vueApp.isOrthoPlaying);
		},
		loadStageClick: function (stageId) {
			loadOrthoStage(stageId);
			vueApp.isOrthoPlaying = false;
			switchOrthoPlay(vueApp.isOrthoPlaying);
		},
		closePlayClick: function () {
			$("#orthoPlayStagesDiv").css("display", "none");
			$("#orthoTreatmentDiv").css("display", "none");
			vueApp.isOrthoPlaying = false;
			switchOrthoPlay(vueApp.isOrthoPlaying);
			if (vueApp.isIntraoralView) {
				loadOrthoStage(-1);
			}
			vueApp.restoreClipping();
			vueApp.leaveModes();
			clearOrtoAccesories();
		},
	},
	computed: {
		midStages: function () {
			return this.currentStages;
		},
		proportion: function () {
			return 100 / (this.currentStages.length);
		}
	},
	mounted: function () {
		// $("#orthoPlayStagesDiv").tooltip();
		window.addEventListener("resize", () => {
			this.windowWidth = window.innerWidth;
		});
	}
};
</script>

<style>
.ortho-button {
	display: inline-block;
	min-width: 90px;
	width: auto;
	height: 35px;
	border: 0;
	cursor: pointer;
	font-size: small;
	background-color: #4687fc;
	text-align: center;
	color: #ffffff;
}

.orto-report-button {
	position: absolute;
	width: 220px;
    bottom: 80px;
	left: calc(50% - 10px);
}

#orthoPlayStagesDiv {
	position: absolute;
	text-align: center;
	left: 10px;
	bottom: 65px;
	z-index: 999;
	display: none;
	width: calc(100% - 215px);
	height: 70px;
}

#orthoPlaySlider {
	text-align: center;
	white-space: nowrap;
	width: 100%;
	height: 35px;
}

#orthoPlayStages {
	position: absolute;
	text-align: center;
	white-space: nowrap;
	width: calc(100% - 105px);
	height: 35px;
	top: 40px;
	left: 15px;
}

.ortho-stage {
	position: absolute;
	padding: 2px;
	font-size: small;
	width: 65px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.ortho-stage-mid {
	width: 27px;
}

.ortho-ellipse {
	position: absolute;
	padding: 3px;
	height: 25px;
}

.horizontal-slider {
	/*position: relative;*/
	width: calc(100% - 105px);
	border-radius: 0;
	outline: none;
	height: 0.4em;
	margin-left: 5px;
	margin-right: 5px;
	display: inline-block;
}

.horizontal-slider .ui-slider-range {
	display: none;
}

.horizontal-slider .ui-slider-handle {
	outline: none;
	width: 1.6em;
	height: 1.6em;
	border-radius: 30px;
	top: -0.6em;
	margin-left: -0.9em;
}

.ortho-play-img {
	width: 40px;
	cursor: pointer;
	display: inline-block;
}

#orthoPlayBtn {
	margin-left: 2px;
}

#originalStage {
	left: -15px;
	width: 55px;
}

#lastStage {
	right: -7px;
}

@media screen and (max-width: 650px) {
	#orthoPlayStagesDiv {
		left: 5px;
		bottom: 60px;
		width: calc(100% - 5px);
	}

	.ortho-stage {
		padding: 1px;
	}

	#originalStage {
		width: 27px;
	}

	#lastStage {
		width: 27px;
	}
}
</style>